import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var Base = function Base() {
  _classCallCheck(this, Base);
};

export { Base as default };